<div class="container-fluid">
    <input type="number" class="form-control w-100" name="answer_{{name}}" placeholder="{{placeholder}}" min="{{min}}"
        max="{{max}}" required #answerValidation="ngModel" [disabled]="summaryMode" (blur)="onClick()"
        [(ngModel)]="numericValue">
    <mat-error *ngIf="question.invalid">required</mat-error>
    <mat-error *ngIf="answerValidation.errors?.minlengt">Answer must be bigger or equal to {{min}}.</mat-error>
    <mat-error *ngIf="answerValidation.errors?.maxLength">Answer must be less than {{max}}.</mat-error>
</div>